import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { AccountFeatureAPI } from 'api/account-feature';
import { toastService } from 'components/molecules/toast';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useTranslate } from 'hooks/use-translation';
import { CREDIT_NOTE_SETTINGS_QUERY_KEY, useCreditNoteEssentialSettingsQuery, useUpdateCreditNoteEssentialSettingMutation } from 'queries/credit-note-settings';
export const useFeatureSettings = ()=>{
    const translate = useTranslate();
    const [featureEnabled, setFeatureEnabled] = useAccountFeature(AccountFeature.CreditNotes);
    const onFeatureStateChange = useCallback((newState)=>{
        setFeatureEnabled(newState);
        if (newState) {
            AccountFeatureAPI.enableFeature(AccountFeature.CreditNotes).then(()=>{
                toastService({
                    title: translate('success'),
                    message: translate('settings.credit_notes.enable.success')
                }).success();
            }).catch(()=>{
                setFeatureEnabled(!newState);
                toastService({
                    title: translate('failure'),
                    message: translate('settings.credit_notes.enable.failure')
                }).error();
            });
        } else {
            AccountFeatureAPI.disableFeature(AccountFeature.CreditNotes).then(()=>{
                toastService({
                    title: translate('success'),
                    message: translate('settings.credit_notes.disable.success')
                }).success();
            }).catch(()=>{
                setFeatureEnabled(!newState);
                toastService({
                    title: translate('failure'),
                    message: translate('settings.credit_notes.disable.failure')
                }).error();
            });
        }
    }, [
        setFeatureEnabled,
        translate
    ]);
    return [
        featureEnabled,
        onFeatureStateChange
    ];
};
export const useUpdateSettings = ()=>{
    const { data: config } = useCreditNoteEssentialSettingsQuery();
    const { mutateAsync, isLoading } = useUpdateCreditNoteEssentialSettingMutation();
    const translate = useTranslate();
    const queryClient = useQueryClient();
    const update = ({ payload, onError })=>{
        mutateAsync({
            payload: {
                ...config,
                ...payload
            }
        }).then((data)=>{
            queryClient.setQueryData(CREDIT_NOTE_SETTINGS_QUERY_KEY, data);
        }).catch((error)=>{
            var _ref;
            var _error_response_data_errors_, _error_response_data_errors, _error_response_data, _error_response;
            toastService({
                title: translate('settings.credit_notes.updation.failure.title'),
                message: (_ref = (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : (_error_response_data_errors = _error_response_data.errors) === null || _error_response_data_errors === void 0 ? void 0 : (_error_response_data_errors_ = _error_response_data_errors[0]) === null || _error_response_data_errors_ === void 0 ? void 0 : _error_response_data_errors_.reason) !== null && _ref !== void 0 ? _ref : translate('settings.credit_notes.updation.failure.message')
            }).error();
            onError === null || onError === void 0 ? void 0 : onError();
        });
    };
    return [
        update,
        isLoading
    ];
};
